(function () {
  class CustomSelect extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: "open" });
      this.selectedValue = "";
      const wrapper = document.createElement("div");
      wrapper.setAttribute("class", "custom-select-wrapper");

      const styles = `
             :host(*) {
            box-sizing: border-box;
            }
            :host([open]) .custom-select-options {
            display: block;
            }

            .custom-select-wrapper {
            position: relative;
            }

            .custom-select {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: transparent;
            padding: 10px;
            border-radius: 8px;
            cursor: pointer;
            position: relative;
            color: inherit;
            }

            .custom-select-options {
            padding: 12px 0;
            display: none;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            background-color: #fff;
            border: 1px solid #ccc;
            border-radius: 20px;
            z-index: 30;
            max-height: 200px;
            overflow-y: auto;
            color: #000;
            cursor: pointer;
            }

            ::slotted(choice) {
            display: block;
            transition: background-color 0.1s ease;
            padding: 0 12px !important;
            }

            ::slotted(choice:hover) {
            background-color: lightblue;
            }
            ::slotted(choice[default]) {
            background-color: transparent;
            opacity: 0.75;
            }
            ::slotted(choice[selected]) {
            background-color: #fff;
            color: orange;
            }
            .selected-option {
            opacity: 0;}

            .arrow {
            opacity: 0;
            }
          `;

      wrapper.innerHTML = `
            <style>
                ${styles}
            </style>

            <div class="custom-select">
             <span class="selected-option">Please Select</span>
              <span class="arrow">&#9662;</span>
            </div>
            <div class="custom-select-options">
              <slot></slot>
            </div>
          `;

      this.shadowRoot.appendChild(wrapper);

     
      this.select = this.shadowRoot.querySelector(".custom-select");
      this.optionsSlot = this.shadowRoot.querySelector("slot");
      this.optionsWrapper = this.shadowRoot.querySelector(
        ".custom-select-options"
      );
      this.id = this.getAttribute("id");

      if (this.id) {
        this.hiddenInput = document.querySelector(`input[for='${this.id}']`);
        this.outerLabel = document.querySelector(`label[for='${this.id}']`);
      }

      this.optionsSlot.addEventListener("slotchange", () => {
        this.options = this.optionsSlot.assignedElements();
      });

      this.toggleOpen = this.toggleOpen.bind(this);
      this.handleOptionSlotClick = this.handleOptionSlotClick.bind(this);
      this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    static get observedAttributes() {
      return ["value"];
    }

    toggleOpen() {
      this.hasAttribute("open")
        ? this.removeAttribute("open")
        : this.setAttribute("open", "");
    }

    handleClickOutside(e) {
      if (!this.contains(e.target)) {
        this.removeAttribute("open");
      }
    }

    selectOption(option) {
      this.setAttribute("value", option.textContent);
      this.options.forEach((opt) => opt.removeAttribute("selected"));
      option.setAttribute("selected", "");
      this.hiddenInput.value = option.textContent;
      this.outerLabel.textContent = option.textContent;
      this.removeAttribute("open");
    }

    handleOptionSlotClick(e) {
      if (e.target.tagName !== "CHOICE") return;
      e.target.hasAttribute("default")
        ? this.removeAttribute("open")
        : this.selectOption(e.target);
    }

    unbindListeners() {
      this.select.removeEventListener("click", this.toggleOpen);
      this.optionsSlot.removeEventListener("click", this.handleOptionSlotClick);
      document.removeEventListener("click", this.handleClickOutside);
    }

    bindListeners() {
      this.select.addEventListener("click", this.toggleOpen);
      this.optionsSlot.addEventListener("click", this.handleOptionSlotClick);
      document.addEventListener("click", this.handleClickOutside);
    }

    connectedCallback() {
      this.bindListeners();
    }

    disconnectedCallback() {
      this.unbindListeners();
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === "value") {
        this.selectedValue = newValue;
      }
    }
  }

  if (!customElements.get("custom-select")) {
    customElements.define("custom-select", CustomSelect);
  }
})();
